export default "__VITE_ASSET__CRxKWABj__"